import React from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import TabbedContent from 'components/molecules/TabbedContent'
import TeamsTeams from 'scenes/management/employees/components/teams/teams'
import TeamsEmployees from 'scenes/management/employees/components/teams/employees'
import { useShowHamburger } from 'utils/helper-device'

const ManagementEmployeesTeamsScene = () => {
	
	const showHamburger = useShowHamburger();
	
	const tabBarItems = [
		{
			key: 'teams',
			text: i18n.t('management:pages.teams.teams.title'),
			scene: ( props ) => {
				return (
					<TeamsTeams
						{ ...props }
					/>
				);
			}
		},
		{
			key: 'employees',
			text: i18n.t('management:pages.teams.employee.title'),
			scene: ( props ) => {
				return (
					<TeamsEmployees
						{ ...props }
					/>
				);
			}
		}
	];
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={i18n.t('management:pages.teams.teams.title')}
				topNavigation={ true }
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementEmployeesTeamsScene
